import React from 'react'
import PropTypes from 'prop-types'

import { useBooleanSelect } from './_hooks'
import { Boolean01 } from './_elements'

const BooleanSelect = ({ component, step }) => {
  const [isSelected, handleSelect] = useBooleanSelect({ component, step })

  const Component = (() => {
    switch (component.type) {
      default:
        return Boolean01
    }
  })()

  return (
    <Component
      handleSelect={handleSelect}
      prompt={component.prompt}
      selected={isSelected}
      slug={component.slug}
    />
  )
}

BooleanSelect.propTypes = {
  component: PropTypes.object.isRequired
}

export default BooleanSelect
